import { REPLACE_BRANCHES, CLEAR_BRANCHES, CLEAR, SET_PAGESIZE, SET_PAGENUMBER, DELETE, SET_BRANCHES_TEXTFILTER, REPLACE_ALL, REPLACE_ALL_BRANCHES } from './actions';

const initialState = {
    branches: [],
    totalResults: 0,
    totalPage: 1,
    pageSize: 10,
    pageNumber: 1,
    filters: {
        textFilter: ''
    },
    branchesForDisplay: {}
}

export default function main (state = initialState, action) {
    switch (action.type) {
        case REPLACE_ALL_BRANCHES:
            return {
                ...state,
                branches: action.branches,
                totalResults: action.totalResults,
                totalPage: action.totalPage
            }
        case REPLACE_BRANCHES:
            return {
                ...state,
                branches: action.branches,
                branchesForDisplay: action.branchesForDisplay
            }
        case CLEAR_BRANCHES:
            return initialState;
        case REPLACE_ALL:
            return {
                ...state,
                branches: action.branches,
                branchesForDisplay: action.branchesForDisplay
            }
        case SET_PAGESIZE:
            return {
                ...state,
                pageSize: action.pageSize
            }
        case SET_PAGENUMBER:
            return {
                ...state,
                pageNumber: action.pageNumber
            }
        case SET_BRANCHES_TEXTFILTER:
            return {
                ...state,
                pageNumber: 1,
                filters: {
                    ...state.filters,
                    ...action.filters
                }
            }
        case CLEAR:
            return initialState
        case DELETE:
            return {
                ...state,
                branches: state.branches.filter(p => p.id !== action.branch.id)
            }
        default:
            return state;
    }
}